import { useQuery } from '@tanstack/react-query'

import { rqKeys } from '@/react-query-keys'
import { apiRequestNew } from '@/helpers/request'
import type { T_UserCardsListRes } from '@/types/responses'

type T_UseUserCardsParams = {
  isAuthorized: boolean
  userId: number | null
}

export const useUserCards = ({
  isAuthorized,
  userId,
}: T_UseUserCardsParams) => (
  useQuery<T_UserCardsListRes>({
    queryKey: [ rqKeys.userCards, userId ],
    queryFn: () => apiRequestNew<T_UserCardsListRes>('GET', '/money/card'),
    enabled: !!isAuthorized && !!userId,
    refetchOnWindowFocus: true,
  })
)
